var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbOnHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 16L22 7C22 6.17 21.5 5.46 20.78 5.16L13.73 2.14C13.5 2.05 13.26 2 13 2L11 2C9.89998 2 8.99998 2.9 8.99998 4L8.99998 10.31L4.42999 9.36L4.10999 9.33C3.69999 9.33 3.31998 9.5 3.04998 9.77L1.99998 10.83L8.58998 17.42C8.94998 17.78 9.44998 18 9.99998 18H20C21.1 18 22 17.1 22 16ZM9.99998 16L5.65998 11.66L11 13L11 4H13L20 7L20 16H9.99998ZM22 20V24H9.99998L9.99998 20H22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbOnHold);
export default __webpack_public_path__ + "static/media/thumb_on_hold.dc19649699da8ef139939eccaf340df0.svg";
export { ForwardRef as ReactComponent };